import React, { useEffect, useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { FranjaFija } from "./franjaFija";

const INTERVALO_MS = 5000;

// Decoraciones exportadas de Figma, de abajo hacia arriba: [número de imagen, x, y, ancho, alto]
// en píxeles del diseño (hero de 1280x330). Se pasan a % para que escalen con el hero.
const ANCHO_DISENO = 1280;
const ALTO_DISENO = 330;
const DECORACIONES = [
  [21, 0, 0, 651, 329], // panel azul
  [25, 1140, 3, 140, 328],
  [11, 124, 6, 253, 329],
  [13, 6, 5, 147, 306],
  [12, 469, 30, 205, 269],
  [14, 109, 41, 152, 130],
  [17, 23, 269, 92, 58],
  [18, 164, 7, 92, 58],
  [19, 255, 290, 48, 30],
  [20, 78, 250, 48, 30],
  [16, 94, 6, 80, 133],
  [24, 319, 6, 73, 133],
  [22, 413, 7, 105, 119],
  [29, 448, 161, 128, 176],
  [15, 435, 274, 77, 95],
  [30, 616, 6, 77, 95],
  [26, 1109, 113, 118, 174],
  [28, 1225, 126, 51, 131],
  [23, 1220, 134, 71, 116],
  [27, 1189, 6, 77, 73],
];

// Hero de la página de asociación: carrusel con las imágenes de fondo de la asociación
// y, encima, un panel azul diagonal con el nombre de la asociación.
export const HeroAsociacion = ({ nombre, imagenes = [] }) => {
  const [indice, setIndice] = useState(0);
  const total = imagenes.length;

  useEffect(() => {
    setIndice(0);
  }, [total]);

  // setTimeout (y no setInterval) para que el contador arranque de nuevo cuando se cambia de slide a mano
  useEffect(() => {
    if (total < 2) return;
    const timer = setTimeout(() => setIndice((i) => (i + 1) % total), INTERVALO_MS);
    return () => clearTimeout(timer);
  }, [indice, total]);

  const anterior = () => setIndice((i) => (i - 1 + total) % total);
  const siguiente = () => setIndice((i) => (i + 1) % total);

  return (
    <FranjaFija izq="#0B2943" lineaAbajo="5px solid #D6192D">
    <section className="hero-asoc">
      {imagenes.map((slide, i) => {
        const src = `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${slide.id_asociacion}/IMAGENES/ASOCIACIONES/FONDOS/${slide.imagen}`;
        return (
          <div
            key={slide.id ?? i}
            className="hero-asoc-slide"
            style={{ opacity: i === indice ? 1 : 0 }}
          >
            <img src={src} alt={`${nombre} ${i + 1}`} className="hero-asoc-foto" />
          </div>
        );
      })}

      <div className="hero-asoc-panel" />
      {DECORACIONES.map(([n, x, y, w, h]) => (
        <img
          key={n}
          src={`/img/asochero-${n}.png`}
          alt=""
          aria-hidden="true"
          className="hero-asoc-deco"
          style={{
            left: `${(x / ANCHO_DISENO) * 100}%`,
            top: `${(y / ALTO_DISENO) * 100}%`,
            width: `${(w / ANCHO_DISENO) * 100}%`,
            height: `${(h / ALTO_DISENO) * 100}%`,
          }}
        />
      ))}

      <div className="hero-asoc-texto">
        <span className="hero-asoc-barra" />
        <h1 className="hero-asoc-titulo">{nombre}</h1>
        <p className="hero-asoc-subtitulo">
          Toda la información sobre pilotos, fechas y reglamentos actualizados
        </p>
      </div>

      {total > 1 && (
        <>
          <div className="hero-asoc-flechas">
            <button type="button" onClick={anterior} aria-label="Imagen anterior">
              <LeftOutlined />
            </button>
            <button type="button" onClick={siguiente} aria-label="Imagen siguiente">
              <RightOutlined />
            </button>
          </div>
          <div className="hero-asoc-puntos">
            {imagenes.map((slide, i) => (
              <button
                key={slide.id ?? i}
                type="button"
                className={i === indice ? "activo" : ""}
                onClick={() => setIndice(i)}
                aria-label={`Ir a la imagen ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </section>
    </FranjaFija>
  );
};
